<svg viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M22.5 7.00018h-9v2h9v-2zm0 8.00002h-9v2h9v-2zm-16.46-4L2.5 7.46018l1.41-1.41 2.12 2.12 4.24-4.24 1.41 1.41-5.64 5.66002zm0 8l-3.54-3.54 1.41-1.41 2.12 2.12 4.24-4.24 1.41 1.41-5.64 5.66z" fill="currentColor"/>
</svg>
